import React from "react";
import { cn } from "../utils/cn";

export const CardSkeletonLoader = ({className}: {className?: string}) => {
  return (
    <div className={cn("w-[379px] h-[110px] rounded-xl bg-white flex gap-2 animate-pulse", className)}>
      <div className="w-[93px] h-[102px] m-1 bg-gray-300 rounded-md"></div>
      <div className="my-5 pr-3 flex-1">
        <div className="flex items-center justify-between mb-1">
          <div className="w-36 h-3 bg-gray-300 mb-1 rounded-md" />
          <div className="w-8 h-3 bg-gray-300 mb-1 rounded-md" />
        </div>
          <div className="w-28 h-3 bg-gray-300 mb-2 rounded-md" />
          <div className="w-full h-3 bg-gray-300 mb-2 rounded-md" />
          <div className="w-full h-3 bg-gray-300 mb-2 rounded-md" />
      </div>
    </div>
  );
};

export const CardProfileSkeletonLoader = ({className}: {className?: string}) => {
  return (
    <div className={cn("w-[379px] h-[94px] rounded-xl bg-white flex gap-2 animate-pulse", className)}>
      <div className="w-10 h-10 my-3 ml-3 bg-gray-300 rounded-full"></div>
      <div className="my-5 pr-3 flex-1">
        <div className="flex items-center justify-between mb-1">
          <div className="w-36 h-3 bg-gray-300 mb-1 rounded-md" />
          <div className="w-8 h-3 bg-gray-300 mb-1 rounded-md" />
        </div>
          <div className="w-28 h-3 bg-gray-300 mb-2 rounded-md" />
          <div className="w-full h-3 bg-gray-300 mb-2 rounded-md" />
      </div>
    </div>
  );
};

